module.exports = __webpack_public_path__ + "static/media/face.9405b2de.png";